'use strict';

var _createForOfIteratorHelper = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _regeneratorRuntime = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _awaitAsyncGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var decoder = require('./decoder.js');

var CarReader = /*#__PURE__*/function () {
  function CarReader(version, roots, blocks) {
    _classCallCheck(this, CarReader);

    this._version = version;
    this._roots = roots;
    this._blocks = blocks;
    this._keys = blocks.map(function (b) {
      return b.cid.toString();
    });
  }

  _createClass(CarReader, [{
    key: "version",
    get: function get() {
      return this._version;
    }
  }, {
    key: "getRoots",
    value: function () {
      var _getRoots = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this._roots);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, this);
      }));

      function getRoots() {
        return _getRoots.apply(this, arguments);
      }

      return getRoots;
    }()
  }, {
    key: "has",
    value: function () {
      var _has = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this._keys.indexOf(key.toString()) > -1);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));

      function has(_x) {
        return _has.apply(this, arguments);
      }

      return has;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        var index;
        return _regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                index = this._keys.indexOf(key.toString());
                return _context4.abrupt("return", index > -1 ? this._blocks[index] : undefined);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, this);
      }));

      function get(_x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "blocks",
    value: function blocks() {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _iterator2, _step2, block;

        return _regeneratorRuntime.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _iterator2 = _createForOfIteratorHelper(_this._blocks);
                _context5.prev = 1;

                _iterator2.s();

              case 3:
                if ((_step2 = _iterator2.n()).done) {
                  _context5.next = 9;
                  break;
                }

                block = _step2.value;
                _context5.next = 7;
                return block;

              case 7:
                _context5.next = 3;
                break;

              case 9:
                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](1);

                _iterator2.e(_context5.t0);

              case 14:
                _context5.prev = 14;

                _iterator2.f();

                return _context5.finish(14);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee4, null, [[1, 11, 14, 17]]);
      }))();
    }
  }, {
    key: "cids",
    value: function cids() {
      var _this2 = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _iterator3, _step3, block;

        return _regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _iterator3 = _createForOfIteratorHelper(_this2._blocks);
                _context6.prev = 1;

                _iterator3.s();

              case 3:
                if ((_step3 = _iterator3.n()).done) {
                  _context6.next = 9;
                  break;
                }

                block = _step3.value;
                _context6.next = 7;
                return block.cid;

              case 7:
                _context6.next = 3;
                break;

              case 9:
                _context6.next = 14;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](1);

                _iterator3.e(_context6.t0);

              case 14:
                _context6.prev = 14;

                _iterator3.f();

                return _context6.finish(14);

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, null, [[1, 11, 14, 17]]);
      }))();
    }
  }], [{
    key: "fromBytes",
    value: function () {
      var _fromBytes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(bytes) {
        return _regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (bytes instanceof Uint8Array) {
                  _context7.next = 2;
                  break;
                }

                throw new TypeError('fromBytes() requires a Uint8Array');

              case 2:
                return _context7.abrupt("return", decodeReaderComplete(decoder.bytesReader(bytes)));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6);
      }));

      function fromBytes(_x3) {
        return _fromBytes.apply(this, arguments);
      }

      return fromBytes;
    }()
  }, {
    key: "fromIterable",
    value: function () {
      var _fromIterable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(asyncIterable) {
        return _regeneratorRuntime.wrap(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(!asyncIterable || !(typeof asyncIterable[Symbol.asyncIterator] === 'function'))) {
                  _context8.next = 2;
                  break;
                }

                throw new TypeError('fromIterable() requires an async iterable');

              case 2:
                return _context8.abrupt("return", decodeReaderComplete(decoder.asyncIterableReader(asyncIterable)));

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee7);
      }));

      function fromIterable(_x4) {
        return _fromIterable.apply(this, arguments);
      }

      return fromIterable;
    }()
  }]);

  return CarReader;
}();

function decodeReaderComplete(reader) {
  var decoder$1, _await$decoder$1$head, version, roots, blocks, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, block;

  return _regeneratorRuntime.async(function decodeReaderComplete$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          decoder$1 = decoder.createDecoder(reader);
          _context.next = 3;
          return _regeneratorRuntime.awrap(decoder$1.header());

        case 3:
          _await$decoder$1$head = _context.sent;
          version = _await$decoder$1$head.version;
          roots = _await$decoder$1$head.roots;
          blocks = [];
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context.prev = 9;
          _iterator = _asyncIterator(decoder$1.blocks());

        case 11:
          _context.next = 13;
          return _regeneratorRuntime.awrap(_iterator.next());

        case 13:
          if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
            _context.next = 19;
            break;
          }

          block = _step.value;
          blocks.push(block);

        case 16:
          _iteratorAbruptCompletion = false;
          _context.next = 11;
          break;

        case 19:
          _context.next = 25;
          break;

        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](9);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 25:
          _context.prev = 25;
          _context.prev = 26;

          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context.next = 30;
            break;
          }

          _context.next = 30;
          return _regeneratorRuntime.awrap(_iterator.return());

        case 30:
          _context.prev = 30;

          if (!_didIteratorError) {
            _context.next = 33;
            break;
          }

          throw _iteratorError;

        case 33:
          return _context.finish(30);

        case 34:
          return _context.finish(25);

        case 35:
          return _context.abrupt("return", new CarReader(version, roots, blocks));

        case 36:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[9, 21, 25, 35], [26,, 30, 34]], Promise);
}

var __browser = true;
exports.CarReader = CarReader;
exports.__browser = __browser;